/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { HotToastService } from '@ngneat/hot-toast';
import { v4 as uuidv4 } from 'uuid';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, ReplaySubject, Subject, Subscription, forkJoin, of } from 'rxjs';
import { NewJobService } from './new-job.service';
import { catchError, debounceTime, distinctUntilChanged, filter, map, pairwise, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { NgSelectComponent } from '@ng-select/ng-select';
import moment, { Moment } from 'moment';
import { ContactFields } from 'app/components/contact-info/contact-info.interface';
import { ContactInfoService } from 'app/components/contact-info/contact-info.component.service';
import { PickerOptions, PickerSelectOptions } from 'app/components/data-picker/data-picker.interface';
import { DataPickerService } from 'app/core/services/data_picker/data_picker.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NewCategoryComponent } from 'app/components/new-category/new-category.component';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import _ from 'lodash';
import 'moment-timezone';
import { ZuperDrawerComponent, ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { moduleKey } from 'app/core/constants/constants';
import { TimeZoneDataType, TimezonePickerService } from 'app/core/services/timezone/timezone-picker.service';
import { CustomFieldConfig } from 'app/components/custom-field-form/custom-field-form.interface';
import { CustomFieldService } from 'app/components/custom-field-form/custom-field.service';
import { ActivatedRoute } from '@angular/router';
import { MetaData } from 'ng-event-bus/lib/meta-data';

@Component({
  selector: 'app-new-job',
  templateUrl: './new-job.component.html',
  styleUrls: ['./new-job.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewJobComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() openDrawer: boolean = false;
  @Input() parentModuleData: any;
  @Input() timezone: string;
  @Input() jobObject: any = {}; //Applicable only for prefill specific job fields - Create Job
  @Input() jobData: any = {}; //Applicable only for prefill entire job fields - Clone Job
  @Input() showTransparentOverlay?: boolean;
  @Input() makeDrawerSizeFit?: boolean;
  @Input() cssPosition?: string;
  @Input() drawerMode?: string = 'over';
  @Input() prefillDetails?: boolean = false;
  @Output() jobFormEmitter: EventEmitter<any> = new EventEmitter();
  drawerName: string = 'new-job-form';
  newJobAPIurls: any;
  newJobForm: UntypedFormGroup;
  isLoaded: boolean = false;
  categories: any[] = [];
  holidays: any[] = [];
  holidaysParamObj: any = {
    'limit': 100
  };
  priorityTypes: any[] = [{
    priorityType: 'Low',
    priorityKey: 'LOW'
  }, {
    priorityType: 'Medium',
    priorityKey: 'MEDIUM'
  }, {
    priorityType: 'High',
    priorityKey: 'HIGH'
  }, {
    priorityType: 'Urgent',
    priorityKey: 'URGENT'
  }];
  dateTimeFormat: 'DD/MM/YYYY HH:mm A';
  dateFormat: 'DD/MM/YYYY';
  estimatedDuration: any = {
    'hours': 0,
    'minutes': 0
  };
  tagsOption: any = {
    module: 'JOB'
  };
  showErrorMessage: boolean = false;
  errorMessage: string = '';
  creatingJob: boolean = false;
  prefillUserData: any = null;
  selectedCategoryServiceTask: any[] = [];
  serviceTaskExecutionType: string;
  serviceTaskLoading: boolean = false;

  customerFetching: boolean = false;
  customerParamObj: any = {
    'count': 10,
    'page': 1,
    'sort': 'ASC',
    'sort_by': 'customer_first_name',
    'filter.is_active': true
  };
  customerPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  customerValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  customerOptions: any[] = [];
  customers: Observable<any[]> = new Observable<any[]>();

  organizationFetching: boolean = false;
  organizationParamObj: any = {
    'count': 10,
    'page': 1,
    'sort': 'ASC',
    'sort_by': 'organization_name',
    'filter.is_active': true
  };
  organizationPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  organizationValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  organizationOptions: any[] = [];
  organizations: Observable<any[]> = new Observable<any[]>();

  propertyFetching: boolean = false;
  propertyParamObj: any = {
    'count': 10,
    'page': 1,
    'sort': 'DESC',
    'sort_by': 'created_at',
    'filter.is_active': true
  };
  propertyPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  propertyValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  propertyOptions: any[] = [];
  properties: Observable<any[]> = new Observable<any[]>();

  employeeFetching: boolean = false;
  employeeParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_assigned_to_team': true,
    'populate_teams': true,
    'filter.is_active': true
  };
  employeePagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  employeeValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  employeeOptions: any[] = [];
  employees: Observable<any[]> = new Observable<any[]>();

  categoryFetching: boolean = false;
  propertyPickedFirst: boolean = false;

  serviceAddressFields: ContactFields = {
    contactFirstName: false,
    contactLastName: false,
    contactEmail: false,
    contactPhone: false,
    street: true,
    enableMapsAutoComplete: true,
    canTruncate: true,
    landmark: true,
    city: true,
    state: true,
    country: false,
    zipcode: true,
    latitude: false,
    longitude: false,
    hideAllLabel: true
  };

  billingAddressFields: ContactFields = {
    contactFirstName: false,
    contactLastName: false,
    contactEmail: false,
    contactPhone: false,
    street: true,
    enableMapsAutoComplete: false,
    canTruncate: true,
    landmark: true,
    city: true,
    state: true,
    country: false,
    zipcode: true,
    latitude: false,
    longitude: false,
    hideAllLabel: true
  };
  serviceAddressForm: string = 'serviceAddress';
  billingAddressForm: string = 'billingAddress';

  openDataPicker: boolean = false;
  drawerModule: string = '';
  dataPickerSubscription: Subscription;
  today: Moment;
  isScheduledOverlapped: boolean = false;
  timezoneDisplayName: string = '';
  userRole: string = '';
  customTimezone: string;
  showTimezoneAlert: boolean = false;
  showEditor: boolean = false;
  cancelAllSubscribtion: Subject<void> = new Subject<void>();

  // timezone
  timezoneSubscription: Subscription;
  defaultTimeZone: string = '';
  timeZoneData: Array<TimeZoneDataType> = [];
  jobScheduled: boolean = false;
  currentPage: string;

  //custom fields
  customFieldConfig: CustomFieldConfig;
  showCustomFields: boolean = false;
  currentCategoryId: string = '';
  customFieldOptions: any = {
    displayInColumn: 4,
    extraClass: 'px-2'
  };

  constructor(
    readonly activatedRoute: ActivatedRoute,
    readonly dataCollectorService: DataCollectorService,
    readonly toast: HotToastService,
    readonly utilityService: UtilityService,
    readonly newJobService: NewJobService,
    readonly zuperDialogService: ZuperDialogService,
    readonly dataPickerService: DataPickerService,
    readonly contactInfoService: ContactInfoService,
    readonly zuperDrawerService: ZuperDrawerService,
    readonly localStorageService: LocalStorageService,
    public timezoneService: TimezonePickerService,
    private customFieldService: CustomFieldService
  ) {
    this.customFieldConfig = {
      expansionDisabled: true,
      originalTemplate: true,
      module:'JOB',
      page: 'new',
      hasCategory: true,
      isQuickCreate: true
    };
    this.currentPage = this.utilityService.collectRouteData(this.activatedRoute.snapshot)?.page;
  }

  ngOnInit(): void {
    this.drawerName = this.drawerName + '_' + uuidv4();
    this.newJobAPIurls = this.newJobService.newJobAPIurls;
    this.dateFormat = this.utilityService.dateFormat;
    this.dateTimeFormat = this.utilityService.dateTimeFormat;
    this.today = moment();
    this.defaultTimeZone = this.utilityService.preferredTimeZone;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showEditor = true;
    }, 500);
  }

  updateTimezoneUsingDSTData(): void{
    const tz = this.newJobForm.controls?.job_timezone?.value;
    const startDate = this.newJobForm.controls?.scheduleStartDate?.value ?? moment();
    this.timeZoneData = this.timezoneService.updateDisplayNamesUsingDST(this.timeZoneData,moment.tz(startDate,tz));
  }

  createJobForm(): void {
    this.newJobForm = new UntypedFormGroup({
      jobTitle: new UntypedFormControl('', Validators.required),
      jobDescription: new UntypedFormControl(''),
      customer: new UntypedFormControl(null),
      organization: new UntypedFormControl(null),
      property: new UntypedFormControl(null),
      category: new UntypedFormControl(null, Validators.required),
      tags: new UntypedFormControl([]),
      priority: new UntypedFormControl('LOW'),
      dueDate: new UntypedFormControl(null),
      assignedTo: new UntypedFormControl(null),
      job_timezone: new UntypedFormControl(this.defaultTimeZone),
      scheduleStartDate: new UntypedFormControl(null),
      scheduleEndDate: new UntypedFormControl(null),
      serviceAddress: new UntypedFormGroup({}),
      billingAddress: new UntypedFormGroup({}),
      sameAsServiceAddress: new UntypedFormControl(true)
    });

    const customFields = new UntypedFormGroup({});
    this.newJobForm.addControl('customFields',customFields);

    this.newJobForm?.controls?.job_timezone.valueChanges.pipe(takeUntil(this.cancelAllSubscribtion)).subscribe((res)=>{
      this.timezone = res;
      this.customTimezone = res;
      moment.tz.setDefault(res);
      });
    this.newJobForm?.controls?.category.valueChanges.pipe(takeUntil(this.cancelAllSubscribtion)).subscribe((res)=>{
      this.getCategoryServiceTask(res);
      this.currentCategoryId = res;
    });

    setTimeout(() => {
      this.showCustomFields = true;
    }, 500);
    this.subscribeFormValueChangesForSDKListeners();
    this.subscribePatchFormValueFromSDK();
  }

  checkScheduledDateError(updatedValue: any): void {
    const { dueDate = null, scheduleStartDate = null, scheduleEndDate = null } = { ...this.newJobForm?.value, ...updatedValue };
    this.showErrorMessage = !dueDate && !scheduleStartDate && !scheduleEndDate;
    this.errorMessage = this.showErrorMessage 
      ? this.utilityService.getLocaleValue('alert.due_date_schedule_date_mandatory', 'Due date or scheduled date is mandatory') 
      : '';
  }

  clearScheduledDate(): void {
    const scheduledStartDateControl = this.newJobForm?.get('scheduleStartDate');
    const scheduledEndDateControl = this.newJobForm?.get('scheduleEndDate');
    scheduledStartDateControl?.setValue(null);
    scheduledEndDateControl?.setValue(null);
    scheduledStartDateControl?.markAsDirty();
    scheduledEndDateControl?.markAsDirty();
  }

  clearDueDate(): void {
    const dueDateControl = this.newJobForm?.get('dueDate');
    dueDateControl?.setValue(null);
    dueDateControl?.markAsDirty();
  }

  getCategoryServiceTask(categoryUid: string): void {
    if (categoryUid) {
      const categoryServiceTaskUrl: string = `${this.dataCollectorService.baseurl()}/jobs/category/${categoryUid}/service_tasks`;
      this.serviceTaskLoading = true;
      this.dataCollectorService.getData(categoryServiceTaskUrl)
        .subscribe((res: any) => {
          const data = res?.data;
          this.selectedCategoryServiceTask = [];
          if (data?.service_execution_type) {
            this.serviceTaskExecutionType = data?.service_execution_type;
          }
          if (data?.service_tasks?.length > 0) {
            this.selectedCategoryServiceTask = data?.service_tasks.map((task: any) => task?.service_task);
          }
          this.serviceTaskLoading = false;
        },
          (error: any) => {
            this.serviceTaskLoading = false;
          });
    }
  }

  getServiceTaskPayload(): any {
    const serviceData = this.selectedCategoryServiceTask.map((task: any, index: number) => {
      const taskData = {
        'sequence_no': index + 1,
        'service_task_master': task?.service_task_master_uid || null,
        'service_task_title': task?.service_task_title,
        'service_task_description': task?.service_task_description || '',
        'estimated_duration': {
            'days': task?.estimated_duration?.days,
            'hours': task?.estimated_duration?.hours,
            'minutes': task?.estimated_duration?.minutes
        },
        'inspection_form': task?.inspection_form?.asset_form_uid || null,
        'asset': null
      };
      if(task?.assigned_to?.user){
        taskData['assigned_to'] = [{
          'user_uid': task?.assigned_to?.user?.user_uid,
          'team_uid': task?.assigned_to?.team?.team_uid
        }];
      }else{
        taskData['assigned_to'] = [];
      }
      return taskData;
    });
    return {
      'execution_type': this.serviceTaskExecutionType,
      'service_tasks': serviceData,
      'is_enabled': true
    };
  }


  drawerOpenedChanged(isOpened: boolean): void {
    if (isOpened) {
      this.createJobForm();
      this.getJobCommonData();

      if(this.timezone === this.timezoneService.getSelectedTimeZone(this.timezone)){
        this.timezone = this.utilityService.preferredTimeZone;
      }

      this.userRole = this.localStorageService.getLocalStorage('user')?.role.role_key || '';
      if (this.jobData && Object.keys(this.jobData).length) {
        this.updateJobFormDataValues();
      } else {
        this.updateJobFormValues();
      }
      this.getAllEmployees();
      this.dataPickerSubscription = this.dataPickerService.onInit.subscribe(
        (pickerValue: any) => {
          if (pickerValue?.length) {
            this.updatePickerValue(pickerValue);
          }
        }
      );
      if(!this.utilityService?.isTimeZoneEnabled){
        this.showTimezoneAlert = !!this.timezone;
      }
      this.customTimezone = this.timezone;
      if (!this.customTimezone) {
        this.customTimezone = this.utilityService.timeZone;
      }
      this.timezoneDisplayName = this.utilityService.getTimezoneDisplayName(this.customTimezone);
      this.newJobForm?.controls?.job_timezone?.setValue(this.customTimezone,{emitEvent: false});
      this.newJobForm?.controls?.scheduleStartDate.valueChanges.pipe(takeUntil(this.cancelAllSubscribtion)).subscribe((scheduleStartDate)=>{
        this.updateTimezoneUsingDSTData();
        this.checkScheduledDateError({scheduleStartDate: scheduleStartDate});
      });
      this.newJobForm?.controls?.scheduleEndDate.valueChanges.pipe(takeUntil(this.cancelAllSubscribtion)).subscribe((scheduleEndDate)=>{
        this.updateTimezoneUsingDSTData();
        this.checkScheduledDateError({scheduleEndDate: scheduleEndDate});
      });
      this.newJobForm?.controls?.dueDate.valueChanges.pipe(takeUntil(this.cancelAllSubscribtion)).subscribe((dueDate)=>{
        this.checkScheduledDateError({dueDate: dueDate});
      });
    } else {
      this.resetJobForm();
      this.showCustomFields = false;
      this.cancelAllSubscribtion.next();
      this.jobFormEmitter.next({ isDrawerClosed: true });
    }
  }

  updateJobFormValues(): void {
    if (this.jobObject && Object.keys(this.jobObject).length) {
      if (this.jobObject?.user?.user_uid) {
        this.prefillUserData = {
          user: this.jobObject?.user,
          team: this.jobObject?.team
        };
      }
      const assignedUsers: any[] = [];
      if (this.jobObject?.assigned_to?.length) {
        this.jobObject?.assigned_to?.forEach((value: any) => {
          const user: any = value.user;
          if (value?.team) {
            user['teams'] = [value?.team];
          }
          assignedUsers.push(user);
        });
      }
      this.newJobForm.patchValue({
        jobTitle: this.jobObject?.job_title || '',
        jobDescription: this.jobObject?.job_description || '',
        customer: this.jobObject?.customer?.customer_uid || null,
        organization: this.jobObject?.organization?.organization_uid || null,
        property: this.jobObject?.property?.property_uid || null,
        category: this.jobObject?.job_category?.category_uid || null,
        tags: this.jobObject?.job_tags || [],
        priority: this.jobObject?.job_priority || 'LOW',
        dueDate: this.jobObject?.due_date ? moment(this.jobObject?.due_date) : null,
        assignedTo: assignedUsers?.length ? assignedUsers : null,
        scheduleStartDate: this.jobObject?.scheduled_start_time ? moment(this.jobObject?.scheduled_start_time) : null,
        scheduleEndDate: this.jobObject?.scheduled_end_time ? moment(this.jobObject?.scheduled_end_time) : null,
        sameAsServiceAddress: !this.jobObject?.customer_billing_address
      });
      if (this.jobObject?.startDate && this.jobObject?.endDate) {
        this.newJobForm.patchValue({
          scheduleStartDate: moment.utc(this.jobObject?.startDate).tz(this.timezone),
          scheduleEndDate: moment.utc(this.jobObject?.endDate).tz(this.timezone)
        });
      }
      if (this.jobObject?.job_tags) {
        this.tagsOption['fieldValue'] = this.jobObject?.job_tags || [];
      }
      if (this.jobObject?.customer_address) {
        setTimeout(() => {
          this.newJobForm?.get('serviceAddress')?.patchValue(this.contactInfoService.populateAddressFields(this.jobObject?.customer_address));
        });
      }
      if (this.jobObject?.customer_billing_address) {
        setTimeout(() => {
          this.newJobForm?.get('billingAddress')?.patchValue(this.contactInfoService.populateAddressFields(this.jobObject?.customer_billing_address));
        });
      }
    }

    this.getCustomer(this.jobObject?.customer, this.jobObject?.customer?.customer_uid ? true : false);
    this.getOrganization(this.jobObject?.organization, this.jobObject?.organization?.organization_uid ? true : false);
    this.getProperty(this.jobObject?.property, this.jobObject?.property?.property_uid ? true : false);
    if(this.newJobForm.value?.assignedTo?.length) {
      this.onEmployeeChange();
    }
    if (this.jobObject?.customer?.customer_timezone && !this.jobScheduled) {
      this.newJobForm.get('job_timezone').setValue(this.jobObject?.customer?.customer_timezone);
    }else if(this.jobObject?.customer?.customer_organization?.organization_timezone  && !this.jobScheduled){
      this.newJobForm.get('job_timezone').setValue(this.jobObject?.customer?.customer_organization?.organization_timezone);
    }else if(this.jobObject?.organization?.organization_timezone  && !this.jobScheduled){
      this.newJobForm.get('job_timezone').setValue(this.jobObject?.organization?.organization_timezone);
    }
  }

  updateJobFormDataValues(): void {
    this.newJobForm.patchValue({
      jobTitle: this.jobData?.job_title || '',
      jobDescription: this.jobData?.job_description || '',
      customer: this.jobData?.customer?.customer_uid || null,
      organization: this.jobData?.organization?.organization_uid || null,
      property: this.jobData?.property?.property_uid || null,
      category: this.jobData?.job_category?.category_uid || null,
      tags: this.jobData?.job_tags || [],
      priority: this.jobData?.job_priority || 'LOW',
      dueDate: this.jobData?.due_date ? moment(this.jobData?.due_date) : null,
      assignedTo: null,
      scheduleStartDate: this.jobData?.scheduled_start_time ? moment(this.jobData?.scheduled_start_time) : null,
      scheduleEndDate: this.jobData?.scheduled_end_time ? moment(this.jobData?.scheduled_end_time) : null,
      sameAsServiceAddress: false
    });
    if (this.jobData?.job_tags) {
      this.tagsOption['fieldValue'] = this.jobData?.job_tags || [];
    }
    if (this.jobData?.customer_address) {
      setTimeout(() => {
        this.newJobForm?.get('serviceAddress')?.patchValue(this.contactInfoService.populateAddressFields(this.jobData?.customer_address));
      });
    }
    if (this.jobData?.customer_billing_address) {
      setTimeout(() => {
        this.newJobForm?.get('billingAddress')?.patchValue(this.contactInfoService.populateAddressFields(this.jobData?.customer_billing_address));
      });
    }
    this.getCustomer(this.jobData?.customer, true);
    this.getOrganization(this.jobData?.organization, true);
    this.getProperty(this.jobData?.property, true);
    if(this.newJobForm.value?.assignedTo?.length) {
      this.onEmployeeChange();
    }
  }

  getJobCommonData(): void {
    this.isLoaded = false;
    this.categoryFetching = true;
    forkJoin([this.dataCollectorService.getData(this.newJobAPIurls.jobCategoryUrl),
    this.dataCollectorService.getData(this.newJobAPIurls.holidayUrl, this.holidaysParamObj)
    ]).subscribe(([categories, holidays]) => {
      this.isLoaded = true;
      this.categoryFetching = false;
      this.categories = categories.data;
      this.holidays = holidays.data;
      if (this.categories?.length) {
        let category: any = this.categories[0];
        if (this.newJobForm.value?.category) {
          category = this.categories.find(value => value?.category_uid === this.newJobForm.value?.category) || category;
        }
        this.newJobForm?.get('category')?.setValue(category.category_uid);
        this.estimatedDuration = category?.estimated_duration || this.estimatedDuration;
        if((!this.jobObject?.startDate && !this.jobObject?.endDate) && (!this.jobObject?.scheduled_start_time && !this.jobObject?.scheduled_end_time)){
          const currentTimeToTopHr = this.utilityService.getNextQuarterHour(moment.tz(moment(),this.timezone ?? this.newJobForm?.get('job_timezone').value),true);
          this.newJobForm?.get('scheduleStartDate').setValue(currentTimeToTopHr);
          this.newJobForm?.get('scheduleEndDate').setValue(
            currentTimeToTopHr.clone().add(this.estimatedDuration['days'] ?? 0, 'days').add(this.estimatedDuration['hours'] ?? 0, 'hours').add(this.estimatedDuration['minutes'] ?? 0, 'minutes')
          );
        }
      }
    }, (error: any) => {
      this.isLoaded = true;
      this.categoryFetching = false;
    });
  }

  //#region Customer Fetching Related Methods
  getCustomer(customer?: any, isPrefill?: boolean): void {
    if (customer?.customer_uid) {
      this.customerParamObj['filter.customer_uid'] = customer?.customer_uid;
    } else {
      delete this.customerParamObj['filter.customer_uid'];
    }
    if (!isPrefill && this.newJobForm.value.organization) {
      this.customerParamObj['filter.customer_organization'] = this.newJobForm.value.organization;
    } else {
      delete this.customerParamObj['filter.customer_organization'];
    }
    this.customerParamObj['filter.keyword'] = '';

    const urlParams = this.utilityService.constructParam(this.customerParamObj);
    this.customerFetching = true;
    this.dataCollectorService.getData(this.newJobAPIurls.customerUrl, urlParams).subscribe((response: any) => {
      this.customerOptions = response.data;
      this.customerPagination.loadingIndex = response.current_page;
      this.customerPagination.totalPage = response.total_pages;
      this.customers = this.newJobForm?.get('customer').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.customerOptions)
      );
      this.customerFetching = false;
      if (customer?.customer_uid) {
        delete this.customerParamObj['filter.customer_uid'];
        setTimeout(() => {
          this.newJobForm.get('customer')?.setValue(customer.customer_uid);
          if (!isPrefill || this.prefillDetails) {
            this.changeJobCustomer(customer);
          }
        });
      }
    }, (error: any) => {
      this.customerFetching = false;
      if (customer?.customer_uid) {
        delete this.customerParamObj['filter.customer_uid'];
      }
    });
  }

  onCustomerSearch(): void {
    this.customers = this.customerValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getCustomers(term))
    );
  }

  onCustomerClear(): void {
    this.customers = this.getCustomers('');
    const organization =  this.getOrganizationDetails();
    if(organization?.organization_timezone  && !this.jobScheduled){
      this.newJobForm.get('job_timezone').setValue(organization?.organization_timezone);
    }else if(!this.jobScheduled){
      this.newJobForm.get('job_timezone').setValue(this.utilityService.preferredTimeZone);
    }
  }

  onCustomerScrollToEnd(): void {
    if (this.customerPagination.loadingIndex < this.customerPagination.totalPage) {
      this.customerPagination.loadingIndex++;
      this.customerParamObj['filter.keyword'] = this.customerPagination.keyword;
      this.customerParamObj['page'] = this.customerPagination.loadingIndex;
      this.customerFetching = true;
      const urlParams = this.utilityService.constructParam(this.customerParamObj);
      this.dataCollectorService.getData(this.newJobAPIurls.customerUrl, urlParams).subscribe(
        (response: any) => {
          this.customerFetching = false;
          this.customerOptions = this.customerOptions.concat(response.data);
          this.customers = this.newJobForm?.get('customer').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.customerOptions)
          );
        }, (error: any) => {
          this.customerFetching = false;
        });
    }
  }

  getCustomers(input: string): Observable<any[]> {
    this.customerPagination.keyword = input ? input : '';
    this.customerParamObj['filter.keyword'] = this.customerPagination.keyword;
    this.customerParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.customerParamObj);
    this.customerFetching = true;
    return this.dataCollectorService.getData(this.newJobAPIurls.customerUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.customerPagination.loadingIndex = response.current_page;
          this.customerPagination.totalPage = response.total_pages;
          this.customerOptions = response.data;
          this.customerFetching = false;
          return response.data;
        }),
      );
  }
  //#endregion

  //#region Organization Fetching Related Methods
  getOrganization(organization?: any, isPrefill?: boolean): void {
    if (organization?.organization_uid) {
      this.organizationParamObj['filter.organization_uid'] = organization?.organization_uid;
    } else {
      delete this.organizationParamObj['filter.organization_uid'];
      if (!isPrefill) {
        const customer: any = this.getCustomerDetails();
        if (customer?.customer_organization?.organization_uid) {
          this.organizationParamObj['filter.organization_uid'] = customer?.customer_organization?.organization_uid;
          this.newJobForm?.get('organization').setValue(customer?.customer_organization?.organization_uid);
        }
      }
    }
    this.organizationParamObj['filter.keyword'] = '';

    const urlParams = this.utilityService.constructParam(this.organizationParamObj);
    this.organizationFetching = true;
    this.dataCollectorService.getData(this.newJobAPIurls.organizationUrl, urlParams).subscribe((response: any) => {
      this.organizationOptions = response.data;
      this.organizationPagination.loadingIndex = response.current_page;
      this.organizationPagination.totalPage = response.total_pages;
      this.organizations = this.newJobForm?.get('organization').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.organizationOptions)
      );
      this.organizationFetching = false;
      if (organization?.organization_uid) {
        delete this.organizationParamObj['filter.organization_uid'];
        setTimeout(() => {
          this.newJobForm?.get('organization').setValue(organization.organization_uid);
          if (!isPrefill) {
            this.changeJobOrganization(organization);
          }
        });
      }
    }, (error: any) => {
      this.organizationFetching = false;
      if (organization?.organization_uid) {
        delete this.organizationParamObj['filter.organization_uid'];
      }
    });
  }

  onOrganizationSearch(): void {
    this.organizations = this.organizationValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getOrganizations(term))
    );
  }

  onOrganizationClear(): void {
    this.organizations = this.getOrganizations('');
    if(!this.jobScheduled){
      this.newJobForm.get('job_timezone').setValue(this.utilityService.preferredTimeZone);
    }
  }

  onOrganizationScrollToEnd(): void {
    if (this.organizationPagination.loadingIndex < this.organizationPagination.totalPage) {
      this.organizationPagination.loadingIndex++;
      this.organizationParamObj['filter.keyword'] = this.organizationPagination.keyword;
      this.organizationParamObj['page'] = this.organizationPagination.loadingIndex;
      this.organizationFetching = true;
      const urlParams = this.utilityService.constructParam(this.organizationParamObj);
      this.dataCollectorService.getData(this.newJobAPIurls.organizationUrl, urlParams).subscribe(
        (response: any) => {
          this.organizationFetching = false;
          this.organizationOptions = this.organizationOptions.concat(response.data);
          this.organizations = this.newJobForm?.get('organization').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.organizationOptions)
          );
        }, (error: any) => {
          this.organizationFetching = false;
        });
    }
  }

  getOrganizations(input: string): Observable<any[]> {
    this.organizationPagination.keyword = input ? input : '';
    this.organizationParamObj['filter.keyword'] = this.organizationPagination.keyword;
    this.organizationParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.organizationParamObj);
    this.organizationFetching = true;
    return this.dataCollectorService.getData(this.newJobAPIurls.organizationUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.organizationPagination.loadingIndex = response.current_page;
          this.organizationPagination.totalPage = response.total_pages;
          this.organizationOptions = response.data;
          this.organizationFetching = false;
          return response.data;
        }),
      );
  }
  //#endregion

  //#region Property Fetching Related Methods
  getProperty(property?: any, isPrefill?: boolean): void {
    let validateOrgParam: boolean = false;
    if (property?.property_uid) {
      this.propertyParamObj['filter.property_uid'] = property.property_uid;
      validateOrgParam = true;
    } else {
      delete this.propertyParamObj['filter.property_uid'];
      if (!isPrefill) {
        if (this.newJobForm.value.customer) {
          delete this.propertyParamObj['filter.organization'];
          this.propertyParamObj['filter.customer'] = this.newJobForm.value.customer;
        } else {
          validateOrgParam = true;
        }
      }
    }
    if (!isPrefill && validateOrgParam) {
      if (this.newJobForm.value.organization) {
        delete this.propertyParamObj['filter.customer'];
        this.propertyParamObj['filter.organization'] = this.newJobForm.value.organization;
      } else {
        delete this.propertyParamObj['filter.organization'];
        delete this.propertyParamObj['filter.customer'];
      }
    }
    this.propertyParamObj['filter.keyword'] = '';

    const urlParams = this.utilityService.constructParam(this.propertyParamObj);
    this.propertyFetching = true;
    this.dataCollectorService.getData(this.newJobAPIurls.propertyUrl, urlParams).subscribe((response: any) => {
      this.propertyOptions = response.data;
      this.propertyPagination.loadingIndex = response.current_page;
      this.propertyPagination.totalPage = response.total_pages;
      this.properties = this.newJobForm?.get('property').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.propertyOptions)
      );
      this.propertyFetching = false;
      if (property?.property_uid) {
        delete this.propertyParamObj['filter.property_uid'];
        setTimeout(() => {
          this.newJobForm?.get('property').setValue(property.property_uid);
          if (!isPrefill) {
            this.changeJobProperty(property);
          }
        });
      }
    }, (error: any) => {
      this.propertyFetching = false;
      if (property?.property_uid) {
        delete this.propertyParamObj['filter.property_uid'];
      }
    });
  }

  onPropertySearch(): void {
    this.properties = this.propertyValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getProperties(term))
    );
  }

  onPropertyClear(): void {
    this.properties = this.getProperties('');
  }

  onPropertyScrollToEnd(): void {
    if (this.propertyPagination.loadingIndex < this.propertyPagination.totalPage) {
      this.propertyPagination.loadingIndex++;
      this.propertyParamObj['filter.keyword'] = this.propertyPagination.keyword;
      this.propertyParamObj['page'] = this.propertyPagination.loadingIndex;
      this.propertyFetching = true;
      const urlParams = this.utilityService.constructParam(this.propertyParamObj);
      this.dataCollectorService.getData(this.newJobAPIurls.propertyUrl, urlParams).subscribe(
        (response: any) => {
          this.propertyFetching = false;
          this.propertyOptions = this.propertyOptions.concat(response.data);
          this.properties = this.newJobForm?.get('property').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.propertyOptions)
          );
        }, (error: any) => {
          this.propertyFetching = false;
        });
    }
  }

  getProperties(input: string): Observable<any[]> {
    this.propertyPagination.keyword = input ? input : '';
    this.propertyParamObj['filter.keyword'] = this.propertyPagination.keyword;
    this.propertyParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.propertyParamObj);
    this.propertyFetching = true;
    return this.dataCollectorService.getData(this.newJobAPIurls.propertyUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.propertyPagination.loadingIndex = response.current_page;
          this.propertyPagination.totalPage = response.total_pages;
          this.propertyOptions = response.data;
          this.propertyFetching = false;
          return response.data;
        }),
      );
  }
  //#endregion

  //#region Assign Employees Fetching Related Methods
  getAllEmployees(): void {
    if (this.prefillUserData?.user?.user_uid) {
      this.employeeParamObj['filter.user_uid'] = this.prefillUserData?.user?.user_uid;
    }
    const urlParams = this.utilityService.constructParam(this.employeeParamObj);
    this.employeeFetching = true;
    this.dataCollectorService.getData(this.newJobAPIurls.userUrl, urlParams).subscribe((response: any) => {
      this.employeeOptions = response.data;
      this.employeePagination.loadingIndex = response.current_page;
      this.employeePagination.totalPage = response.total_pages;
      this.employees = this.newJobForm?.get('assignedTo').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.employeeOptions)
      );
      this.employeeFetching = false;
      if (this.prefillUserData?.user?.user_uid) {
        delete this.employeeParamObj['filter.user_uid'];
        const assignedEmployee: any = this.employeeOptions?.find(user => user?.user_uid === this.prefillUserData?.user?.user_uid) || null;
        if (assignedEmployee) {
          setTimeout(() => {
            this.newJobForm?.get('assignedTo').setValue([assignedEmployee]);
            this.onEmployeeChange();
          });
        }
      }
    }, (error: any) => {
      this.employeeFetching = false;
      if (this.prefillUserData?.user?.user_uid) {
        delete this.employeeParamObj['filter.user_uid'];
      }
    });
  }

  onEmployeeSearch(): void {
    this.employees = this.employeeValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getEmployees(term))
    );
  }

  onEmployeeClear(): void {
    this.employees = this.getEmployees('');
  }

  onEmployeeScrollToEnd(): void {
    if (this.employeePagination.loadingIndex < this.employeePagination.totalPage) {
      this.employeePagination.loadingIndex++;
      this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
      this.employeeParamObj['page'] = this.employeePagination.loadingIndex;
      this.employeeFetching = true;
      const urlParams = this.utilityService.constructParam(this.employeeParamObj);
      this.dataCollectorService.getData(this.newJobAPIurls.userUrl, urlParams).subscribe(
        (response: any) => {
          this.employeeFetching = false;
          this.employeeOptions = this.employeeOptions.concat(response.data);
          this.employees = this.newJobForm?.get('assignedTo').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.employeeOptions)
          );
        }, (error: any) => {
          this.employeeFetching = false;
        });
    }
  }

  getEmployees(input: string): Observable<any[]> {
    this.employeePagination.keyword = input ? input : '';
    this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
    this.employeeParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.employeeParamObj);
    this.employeeFetching = true;
    return this.dataCollectorService.getData(this.newJobAPIurls.userUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.employeePagination.loadingIndex = response.current_page;
          this.employeePagination.totalPage = response.total_pages;
          this.employeeOptions = response.data;
          this.employeeFetching = false;
          return response.data;
        }),
      );
  }
  //#endregion

  changeJobCustomer(event: any): void {
    if (!this.newJobForm.value?.organization || (event?.customer_organization?.organization_uid &&
      event?.customer_organization?.organization_uid !== this.newJobForm.value?.organization)) {
      this.newJobForm.patchValue({
        property: null
      });
      this.newJobForm?.get('property')?.markAsUntouched();
      this.getProperty();
      this.getOrganization();
    }
    if (event?.customer_timezone && !this.jobScheduled) {
      this.newJobForm.get('job_timezone').setValue(event?.customer_timezone);
    }else if(event?.customer_organization?.organization_timezone  && !this.jobScheduled){
      this.newJobForm.get('job_timezone').setValue(event?.customer_organization?.organization_timezone);
    }
    this.updateBillingAddress();
    this.updateServiceAddress();
  }

  changeJobOrganization(event: any): void {
    const customer: any = this.getCustomerDetails();
    if (event && customer?.customer_organization?.organization_uid === event?.organization_uid) {
      if(!this.propertyPickedFirst) {
        this.newJobForm.patchValue({
          property: null
        });
      }
      this.getProperty();
    } else {
      this.newJobForm.patchValue({
        customer: null,
        property: null
      });
      if (!event?.organization_uid && !this.newJobForm?.value?.customer) {
        delete this.organizationParamObj['filter.organization_uid'];
      }
      this.newJobForm?.get('customer')?.markAsUntouched();
      this.getProperty();
      this.getCustomer();
    }
    if (customer?.customer_timezone && !this.jobScheduled) {
      this.newJobForm.get('job_timezone').setValue(customer?.customer_timezone);
    }else if(customer?.customer_organization?.organization_timezone  && !this.jobScheduled){
      this.newJobForm.get('job_timezone').setValue(customer?.customer_organization?.organization_timezone);
    }else if(event?.organization_timezone  && !this.jobScheduled){
      this.newJobForm.get('job_timezone').setValue(event?.organization_timezone);
    }
    this.updateBillingAddress();
    this.updateServiceAddress();
  }

  changeJobProperty(_event: any): void {
    if(!this.newJobForm.value.customer && !this.newJobForm.value.organization){
      if(this.newJobForm?.value?.property?.property_uid){
        this.propertyPickedFirst = true;
      }
      if(this.newJobForm?.value.property && _event.property_organization?.organization_uid){
        if(_event.property_organization?.organization_uid){
          this.organizationOptions = [];
          this.organizationOptions.push(_event.property_organization);
        }
        this.organizations = this.newJobForm?.get('organization').valueChanges.pipe(
          startWith(''),
          map((value: any) => this.organizationOptions)
        );
        this.newJobForm?.get('organization')?.patchValue(_event.property_organization?.organization_uid);
      }
      if(this.newJobForm?.value?.property && _event.property_customers) {
        this.customerOptions = [];

        _event.property_customers.forEach((item) => {
          this.customerOptions.push(item.customer);
        });

        this.customers = this.newJobForm?.get('customer').valueChanges.pipe(
          startWith(''),
          map((value: any) => this.customerOptions)
        );
      }
      this.getProperty(this.newJobForm?.value?.property);
    }
    this.updateServiceAddress();
  }

  changeJobCategory(event: any): void {
    if (event) {
      this.estimatedDuration = event?.estimated_duration || {
        'hours': 0,
        'minutes': 0,
        'days': 0
      };
      const startDate = this.newJobForm.get('scheduleStartDate').value;
      if(startDate && this.estimatedDuration){
        const categoryBasedEndTime = moment(startDate)
        .add(this.estimatedDuration.days, 'days')
        .add(this.estimatedDuration.hours, 'hours')
        .add(this.estimatedDuration.minutes, 'minutes');;
        this.newJobForm.get('scheduleEndDate').setValue(categoryBasedEndTime);
      }
    }
  }

  changeScheduledStartDate(event: any): void {
    if (event?.value) {
      this.jobScheduled = true;
      this.newJobForm.get('scheduleEndDate')?.setValue(this.getEndDateTime(event?.value, this.estimatedDuration));
    }
  }

  getEndDateTime(date: string, duration: any): any {
    return moment(date).add(duration['days'] ?? 0, 'days').add(duration['hours'] ?? 0, 'hours').add(duration['minutes'] ?? 0, 'minutes');
  }

  getCustomerDetails(): any {
    const customerUID: string = this.newJobForm?.value?.customer;
    if (customerUID) {
      return this.customerOptions?.find(customer => customer.customer_uid === customerUID) || null;
    }
    return null;
  }

  getOrganizationDetails(): any {
    const organizationUID: string = this.newJobForm?.value?.organization;
    if (organizationUID) {
      return this.organizationOptions?.find(organization => organization.organization_uid === organizationUID) || null;
    }
    return null;
  }

  getPropertyDetails(): any {
    const propertyUID: string = this.newJobForm?.value?.property;
    if (propertyUID) {
      return this.propertyOptions?.find(property => property.property_uid === propertyUID) || null;
    }
    return null;
  }

  userSelectionChanged(event: any, item: any): void {
    event.stopPropagation();
    if (!event?.target?.checked && this.newJobForm.value?.assignedTo?.find(value => item?.user_uid === value?.user_uid)) {
      this.unassignEmployee(item);
    }
  }

  unassignEmployee(item: any): void {
    if (this.newJobForm.value?.assignedTo?.length) {
      const selectedUsers: any[] = this.newJobForm.value?.assignedTo?.filter(value => item?.user_uid !== value?.user_uid);
      this.newJobForm?.get('assignedTo').setValue(selectedUsers);
    }
  }

  onEmployeeChange(): void {
    const assignedTo: any[] = this.newJobForm.value?.assignedTo;
    if (assignedTo?.length) {
      assignedTo.forEach(async (userDetails: any) => {
        if (!userDetails?.work_hours) {
          const userUid = userDetails?.user_uid;
          const userWorkHours = await this.newJobService.getUserWorkHours(userUid);
          userDetails['work_hours'] = userWorkHours;
        }
      });
      this.newJobForm.controls['assignedTo'].setValue(assignedTo);
    }
  }

  isEmployeeAssigned(item: any): boolean {
    if (this.newJobForm.value?.assignedTo?.length) {
      const selectedUser: any = this.newJobForm.value?.assignedTo?.find(value => item?.user_uid === value?.user_uid);
      return selectedUser ? true : false;
    }
    return false;
  }

  getEmployeeTeam(user: any): any {
    let selectedTeam: any = user.teams[0]?.team_name;
    if (this.prefillUserData?.user && this.prefillUserData?.team && this.prefillUserData?.user?.user_uid === user?.user_uid) {
      selectedTeam = user.teams?.find(team => team?.team_uid === this.prefillUserData?.team?.team_uid)?.team_name || selectedTeam;
    }
    return selectedTeam;
  }

  onBillingAddressFlagChange(event: any): void {
    if (event?.target) {
      setTimeout(() => {
        this.newJobForm?.get('billingAddress').setValue(this.newJobForm.value?.serviceAddress);
      });
    }
  }

  updateServiceAddress(): void {
    let addressFormValue: any = null;
    if (this.newJobForm.value?.property) {
      const property: any = this.getPropertyDetails();
      addressFormValue = this.contactInfoService.populateAddressFields(property?.property_address);
    } else if (this.newJobForm?.value?.customer) {
      const customer: any = this.getCustomerDetails();
      addressFormValue = this.contactInfoService.populateAddressFields(customer?.customer_address);
    } else if (this.newJobForm.value?.organization) {
      const organization: any = this.getOrganizationDetails();
      addressFormValue = this.contactInfoService.populateAddressFields(organization?.organization_address);
    } else {
      addressFormValue = this.contactInfoService.populateAddressFields(null);
    }
    setTimeout(() => {
      this.newJobForm?.get('serviceAddress')?.patchValue(addressFormValue);
    });
  }

  updateBillingAddress(): void {
    this.newJobForm?.get('sameAsServiceAddress').setValue(false);
    let addressFormValue: any = null;
    const customer: any = this.getCustomerDetails();
    if (customer?.customer_organization?.organization_billing_address) {
      addressFormValue = this.contactInfoService.populateAddressFields(customer?.customer_organization?.organization_billing_address);
    } else if (this.newJobForm.value?.organization) {
      const organization: any = this.getOrganizationDetails();
      addressFormValue = this.contactInfoService.populateAddressFields(organization?.organization_billing_address);
    } else if (customer) {
      addressFormValue = this.contactInfoService.populateAddressFields(customer?.customer_billing_address);
    } else {
      addressFormValue = this.contactInfoService.populateAddressFields(null);
      this.newJobForm?.get('sameAsServiceAddress').setValue(true);
    }
    setTimeout(() => {
      this.newJobForm?.get('billingAddress')?.patchValue(addressFormValue);
    });
  }

  createNewCustomer(select: NgSelectComponent): void {
    if (select) {
      select.close();
      this.openDataPicker = true;
      this.drawerModule = 'CUSTOMER';
    }
  }

  createNewOrganization(select: NgSelectComponent): void {
    if (select) {
      select.close();
      this.openDataPicker = true;
      this.drawerModule = 'ORGANIZATION';
    }
  }

  createNewProperty(select: NgSelectComponent): void {
    if (select) {
      select.close();
      this.openDataPicker = true;
      this.drawerModule = 'PROPERTY';
    }
  }

  createNewCategory(select: NgSelectComponent): void {
    if (select) {
      select.close();
      const category: MatDialogRef<NewCategoryComponent> = this.zuperDialogService.openCustom(NewCategoryComponent,
        {
          extraClass: 'new-category-form',
          data: {}
        });
      category.disableClose = true;
      category.afterClosed().subscribe((result: any) => {
        if (result?.category) {
          this.categoryFetching = true;
          this.dataCollectorService.getData(this.newJobAPIurls.jobCategoryUrl).subscribe((categories) => {
            this.categoryFetching = false;
            this.categories = categories.data;
            setTimeout(() => {
              this.newJobForm?.get('category')?.setValue(result?.category?.category_uid);
              this.estimatedDuration = result?.category?.estimated_duration || {
                'hours': 0,
                'minutes': 0
              };
            });
          }, (error: any) => {
            this.categoryFetching = false;
          });
        }
      });
    }
  }

  changeTags(event: any): void {
    this.newJobForm?.get('tags')?.setValue(event);
  }

  enableMeridian(): boolean {
    const formatValue: string = this.dateTimeFormat?.toLowerCase() || '';
    return formatValue?.includes('hh:mm a');
  }

  //#region Data Picker
  dataPickerEventHandler(event: any): void {
    this.openDataPicker = false;
    this.drawerModule = '';
  }

  getDataPickerOptions(): PickerOptions {
    const pickerOptions: PickerOptions = {
      showListCount: true,
      position: 'right',
      mode: 'over',
      hasBackDrop: false,
      allowQuickCreate: true,
      showQuickCreateOnly: true,
      prefillValues: this.getQuickCreatePrefillValues(),
      selectOption: PickerSelectOptions.select
    };
    if (this.drawerModule === 'CUSTOMER') {
      pickerOptions['header'] = {
        displayKey: 'create.customer.text',
        displayName: 'Create Customer'
      };
      pickerOptions['footer'] = {
        displayKey: 'create.customer.text',
        displayName: 'Create Customer'
      };
    } else if (this.drawerModule === 'ORGANIZATION') {
      pickerOptions['header'] = {
        displayKey: 'create.organization.text',
        displayName: 'Create Organization'
      };
      pickerOptions['footer'] = {
        displayKey: 'create.organization.text',
        displayName: 'Create Organization'
      };
    } else if (this.drawerModule === 'PROPERTY') {
      pickerOptions['header'] = {
        displayKey: 'create.property.text',
        displayName: 'Create Property'
      };
      pickerOptions['footer'] = {
        displayKey: 'create.property.text',
        displayName: 'Create Property'
      };
    }
    return pickerOptions;
  }

  getQuickCreatePrefillValues(): any {
    if (['CUSTOMER', 'PROPERTY'].includes(this.drawerModule)) {
      return {
        'organization': this.newJobForm.value.organization ?? null
      };
    }
    return null;
  }

  updatePickerValue(pickerValue: any): void {
    if (this.drawerModule === 'CUSTOMER' && pickerValue?.[0].customer_uid) {
      this.getCustomer(pickerValue[0]);
    } else if (this.drawerModule === 'ORGANIZATION' && pickerValue?.[0].organization_uid) {
      this.getOrganization(pickerValue[0]);
    } else if (this.drawerModule === 'PROPERTY' && pickerValue?.[0].property_uid) {
      this.getProperty(pickerValue[0]);
    }
  }
  //#endregion

  resetJobForm(): void {
    this.newJobForm = null;
    this.jobObject = null;
    this.prefillUserData = null;
    this.isLoaded = true;
    this.customerParamObj['filter.keyword'] = '';
    this.customerParamObj['page'] = 1;
    this.customerFetching = false;
    this.organizationParamObj['filter.keyword'] = '';
    this.organizationParamObj['page'] = 1;
    this.organizationFetching = false;
    this.propertyParamObj['filter.keyword'] = '';
    this.propertyParamObj['page'] = 1;
    this.propertyFetching = false;
    this.employeeParamObj['filter.keyword'] = '';
    this.employeeParamObj['page'] = 1;
    this.employeeFetching = false;
    this.estimatedDuration = {
      'hours': 0,
      'minutes': 0
    };
    this.categoryFetching = false;
    this.showErrorMessage = false;
    this.errorMessage = '';
    this.dataPickerSubscription?.unsubscribe();
    this.drawerModule = '';
    this.openDataPicker = false;
    this.isScheduledOverlapped = false;
    this.customTimezone = '';
    this.jobScheduled = false;
  }

  showError(controlName: string): boolean {
    return this.newJobForm?.get(controlName)?.touched && !this.newJobForm?.get(controlName)?.valid;
  }

  createNewJob(): void {
    if (this.creatingJob) {
      return null;
    }
    this.newJobForm.markAllAsTouched();
    this.customFieldService?.formBuilderSubscription.next(true);
    const formValue: any = this.newJobForm.value;
    if(formValue?.sameAsServiceAddress){
      setTimeout(() => {
        this.newJobForm?.get('billingAddress').setValue(this.newJobForm.value?.serviceAddress);
      });
    }
    if (!formValue?.customer && !formValue.organization) {
      this.showErrorMessage = true;
      this.errorMessage = this.utilityService.getLocaleValue('alert.customer_or_organization_mandatory', 'Customer or organization is mandatory');
    } else if (!formValue.dueDate && !formValue.scheduleStartDate && !formValue.scheduleEndDate) {
      this.showErrorMessage = true;
      this.errorMessage = this.utilityService.getLocaleValue('alert.due_date_schedule_date_mandatory', 'Due date or scheduled date is mandatory');
    } else if (formValue.scheduleStartDate && formValue.scheduleEndDate && moment(formValue.scheduleEndDate).isSameOrBefore(formValue.scheduleStartDate)) {
      this.showErrorMessage = true;
      this.errorMessage = this.utilityService.getLocaleValue('alert.scheduled_start_end_date_time', 'Scheduled End Date & Time should be after Scheduled Start Date & Time');
    } else {
      this.showErrorMessage = false;
    }

    const isValid: boolean = this.newJobForm.valid && !this.showErrorMessage;
    if (isValid && formValue.scheduleStartDate && formValue.scheduleEndDate && formValue.assignedTo?.length) {
      this.getJobScheduleOverlap(formValue);
    } else if (isValid) {
      this.isScheduledOverlapped = false;
      this.creatingNewJob();
    }
  }

  getJobScheduleOverlap(formValue: any): void {
    const selectedTimezone = this.newJobForm.get('job_timezone').value || this.timezone;
    const assignedTo: any[] = formValue.assignedTo.map(data => data?.user_uid);
    const payload: any = {
      'from_date': moment.tz(moment(formValue.scheduleStartDate).format('YYY-MM-DD HH:mm:ss'), 'YYY-MM-DD HH:mm:ss', selectedTimezone).utc().format('YYYY-MM-DD HH:mm:ss'),
      'to_date':moment.tz(moment(formValue.scheduleEndDate).format('YYY-MM-DD HH:mm:ss'), 'YYY-MM-DD HH:mm:ss', selectedTimezone).utc().format('YYYY-MM-DD HH:mm:ss'),
      'user_uid': assignedTo.join(',')
    };
    this.creatingJob = true;
    this.dataCollectorService.putData(this.newJobService.scheduleOverlapUrl, payload).subscribe((response: any) => {
      this.validateJobScheduleOverlap(response.data, formValue.assignedTo, moment(formValue.scheduleStartDate), moment(formValue.scheduleEndDate));
      this.creatingJob = false;
    }, (_err: any) => {
      this.creatingJob = false;
    });
  }

  validateJobScheduleOverlap(overlapData: any[], assignedTo: any[], scheduledStartTime: Moment, scheduledEndTime: Moment ): void {
    scheduledStartTime = moment.tz(scheduledStartTime.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', this.customTimezone).utc(false);
    scheduledEndTime = moment.tz(scheduledEndTime.format('YYYY-MM-DD HH:mm:ss'),'YYYY-MM-DD HH:mm:ss', this.customTimezone).utc(false);
    this.isScheduledOverlapped = false;
    const overlapValidation: any = {
      job: {},
      timeoff: {},
      shifts: {},
      nonJobEvent: {}
    };
    const warningMessage: string[] = [];
    const formValue: any = this.newJobForm.value;
    const timeFormat = 'HH:mm:ss';
    const startTime = moment(formValue.scheduleStartDate.format(timeFormat), timeFormat);
    const endTime = moment(formValue.scheduleEndDate.format(timeFormat), timeFormat);

    //Holiday Validation
    let isHoliday: boolean = false;
    this.holidays?.forEach((holiday: any) => {
      if (this.newJobService?.isDateConflict(formValue.scheduleStartDate, formValue.scheduleEndDate, moment(holiday?.date).startOf('day'), moment(holiday?.date).endOf('day'))) {
        warningMessage.push(`<p>${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.holiday', 'Job is scheduled on a holiday')} : ${moment(holiday?.date).format(this.dateFormat)} (${holiday?.holiday_name})</p>`);
        isHoliday = true;
        return false;
      }
    });
    //Business Hours Validation
    let isPastBusinessHours: boolean = false;
    if (formValue.scheduleStartDate?.isSame(formValue.scheduleEndDate, 'date')) {
      const businessStartTime = moment(this.newJobService.getBusinessHours('start'), timeFormat);
      const businessEndTime = moment(this.newJobService.getBusinessHours('end'), timeFormat);
      if (!startTime.isBetween(businessStartTime, businessEndTime, undefined, '[)') || !endTime.isBetween(businessStartTime, businessEndTime, undefined, '(]')) {
        isPastBusinessHours = true;
      }
    }

    //Work hours
    const outOfWorkHourUsers: string[] = [];
    assignedTo.forEach((userDetails: any) => {
      let isPastWorkHours = false;
      const workHours = userDetails?.work_hours;
       let workStartTime = _.find(workHours, { 'day': scheduledStartTime.format('dddd') })?.start_time;
      let workEndTime = _.find(workHours, { 'day': scheduledEndTime.format('dddd') })?.end_time;
      if (!this.utilityService.isEmptyOrUndefined(workStartTime) && !this.utilityService.isEmptyOrUndefined(workEndTime)) {
        workStartTime = moment(moment(workStartTime, 'LT').tz(this.customTimezone).format('LT'), 'LT');
        workEndTime = moment(moment(workEndTime, 'LT').tz(this.customTimezone).format('LT'), 'LT');
        if (!startTime.isBetween(workStartTime, workEndTime, undefined, '[)') || !endTime.isBetween(workStartTime, workEndTime, undefined, '(]')) {
          isPastWorkHours = true;
        }
      }
      else {
        isPastWorkHours = false;
      }
      if (isPastWorkHours) {
        const userName = this.utilityService.concatTwoStrings(userDetails?.first_name, userDetails?.last_name);
        outOfWorkHourUsers.push(userName);
      }
    });

    //Due Date Validation
    let isDueBy: boolean = false;
    if (formValue.scheduleEndDate && formValue.dueDate && moment(formValue.scheduleEndDate).isAfter(moment(formValue.dueDate).endOf('day'))) {
      isDueBy = true;
    }

    let customJobShiftData: any[] = [];
    if (overlapData?.length) {
      overlapData.forEach((data: any) => {
        if (data?.jobs.length > 0 || data?.timeoff.length > 0 || data?.user_shifts.length > 0 || data?.non_job_events?.length) {
          //Job Overlaps Validation
          data?.jobs?.forEach((job: any) => {
            const assignedUser: any[] = job?.assigned_to;
            assignedUser?.forEach((assignee: any) => {
              const user = _.get(assignee, 'user');
              if (user?.user_uid && assignedTo?.find(udata => udata?.user_uid === user?.user_uid) && !overlapValidation.job[user?.user_uid]) {
                overlapValidation.job[user?.user_uid] = user?.first_name + ' ' + (user?.last_name || '');
              }
            });
          });

          //Non-job event overlaps valdation
          data?.non_job_events?.forEach((event: any) => {
            const assignedUser: any[] = event?.assigned_to;
            assignedUser?.forEach((assignee: any) => {
              const user = _.get(assignee, 'user');
              if (user?.user_uid && assignedTo?.find(udata => udata?.user_uid === user?.user_uid) && !overlapValidation.nonJobEvent[user?.user_uid]) {
                overlapValidation.nonJobEvent[user?.user_uid] = user?.first_name + ' ' + (user?.last_name || '');
              }
            });
          });

          //Time Off Validations
          data?.timeoff?.forEach((timeoff: any) => {
            const user = timeoff?.['requested_by'];
            if (user?.user_uid && assignedTo?.find(udata => udata?.user_uid === user?.user_uid) && !overlapValidation.timeoff[user?.user_uid]) {
              overlapValidation.timeoff[user?.user_uid] = user?.first_name + ' ' + (user?.last_name || '');
            }
          });

          //Shift Hours Validation
          customJobShiftData = [];
          data?.user_shifts?.forEach((shift: any) => {
            const user = shift?.['user_details'];
            if (user?.user_uid && assignedTo?.find(udata => udata?.user_uid === user?.user_uid) && !overlapValidation.shifts[user?.user_uid]) {
              if (!this.utilityService.isEmptyOrUndefined(shift?.start_date_time) && !this.utilityService.isEmptyOrUndefined(shift?.end_date_time)) {
                const shiftStartTime = moment.utc(shift?.start_date_time);
                const shiftEndTime = moment.utc(shift?.end_date_time);
                const jobInShiftHours = scheduledStartTime.isBetween(shiftStartTime, shiftEndTime, null, '[]') && scheduledEndTime.isBetween(shiftStartTime, shiftEndTime, null, '[]');
                customJobShiftData.push({jobInShiftHours: jobInShiftHours, userDetails: user});
              }
            }
          });
          assignedTo.forEach((assignedToUser: any) => {
            const userJobAndShift = customJobShiftData.filter((customData: any) => customData?.userDetails?.user_uid === assignedToUser?.user_uid);
            if (userJobAndShift?.length) {
              const isJobFitsInShift = userJobAndShift.find((customUserJobAndShift: any) => customUserJobAndShift?.jobInShiftHours);
            if (!isJobFitsInShift) {
                overlapValidation.shifts[assignedToUser?.user_uid] = assignedToUser?.first_name + ' ' + (assignedToUser?.last_name || '');
              };
            }
          });
        }
      });
    }
    //Date & Time Warnings
    if (!isHoliday && Object.keys(overlapValidation.timeoff)?.length) {
      const users: string[] = [];
      Object.keys(overlapValidation.timeoff).forEach((key: string) => {
        users.push(overlapValidation.timeoff[key]);
      });
      warningMessage.push(`<p>${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.timeoff', 'Job is scheduled on a timeoff for user')} : <b>${_.uniq(users).join(', ')}</b></p>`);
    } else if (!isHoliday && isPastBusinessHours) {
      warningMessage.push(`<p>${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.business_hours', 'Job is scheduled outside business hours')}</p>`);
    } else if (!isHoliday && isDueBy) {
      warningMessage.push(`<p>${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.duedate', 'Job is due by')} ${formValue.dueDate?.format(this.dateFormat)}</p>`);
    }

    //Work Hours Warning
    if (outOfWorkHourUsers.length) {
      warningMessage.push(`<p>${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.work_hours', 'Job is scheduled outside work hours of user')} <b>${outOfWorkHourUsers.join(', ')}</b></p>`);
    }
    //Shift Hours Warning
    if (Object.keys(overlapValidation.shifts)?.length) {
      const users: string[] = [];
      Object.keys(overlapValidation.shifts).forEach((key: string) => {
        users.push(overlapValidation.shifts[key]);
      });
      warningMessage.push(`<p>${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.shift_hours_exceed', 'Job is scheduled outside the shift hours of the user')} <b>${_.uniq(users).join(', ')}</b></p>`);
    }
    //Jobs Overlap Warning
    if (Object.keys(overlapValidation.job)?.length) {
      const users: string[] = [];
      Object.keys(overlapValidation.job).forEach((key: string) => {
        users.push(overlapValidation.job[key]);
      });
      warningMessage.push(`<p><b>${_.uniq(users).join(', ')}</b> ${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.overlap', 'has already been assigned to another job in this time interval')}</p>`);
    }

    //Non-Job Event Overlap Warning
    if (Object.keys(overlapValidation.nonJobEvent)?.length) {
      const users: string[] = [];
      Object.keys(overlapValidation.nonJobEvent).forEach((key: string) => {
        users.push(overlapValidation.nonJobEvent[key]);
      });
      warningMessage.push(`<p><b>${_.uniq(users).join(', ')}</b> ${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.non_job_event_overlap', 'has already been assigned to a non-job event during this time interval.')}</p>`);
    }
    if (warningMessage?.length) {
      this.isScheduledOverlapped = true;
    }
    if (this.isScheduledOverlapped) {
      const scheduleConfirmationDialog = this.zuperDialogService.open({
        title: this.utilityService.getLocaleValue('confirm.job.schedule.dialog.title', 'Confirm Job Schedule'),
        type: 'error',
        message: `<div class="space-y-2 mt-2">${warningMessage.join('')}</div>`,
        actions: {
          confirm: {
            show: true,
            label: 'Continue',
            color: 'primary',
            confirmDisplayKey: 'continue.text'
          },
          cancel: {
            show: true,
            label: 'Cancel',
            cancelDisplayKey: 'cancel.text'
          }
        },
        dismissible: false,
        extraClass: 'w-1/3'
      });
      scheduleConfirmationDialog.afterClosed().subscribe((result: any) => {
        if (result === true) {
          this.isScheduledOverlapped = false;
          this.creatingNewJob();
        }
      });
    } else {
      this.creatingNewJob();
    }
  }

  creatingNewJob(): void {
    const formValue: any = this.newJobForm.value;
    if (this.newJobForm.valid && !this.showErrorMessage && !this.isScheduledOverlapped) {
      const payload = {};
      if (formValue.assignedTo?.length) {
        const assignedTo = formValue.assignedTo.map((data: any) => ({
          team_uid: data?.teams?.[0]?.team_uid || null,
          user_uid: data?.user_uid
        }));
        payload['assigned_to'] = assignedTo;
      }

      payload['custom_fields'] = this.customFieldService.constructCustomFields(this.newJobForm.controls['customFields'] as UntypedFormGroup,true, 'JOB');

      //Add request reference
      if (this.jobObject?.request_uid) {
        payload['request'] = this.jobObject?.request_uid;
      }

      //Add asset reference - WEB-1415
      if (this.jobObject?.asset_uid) {
        payload['assets'] = [{asset: this.jobObject?.asset_uid, asset_inspection_form_submission_uid: "", remarks: ""}];
      }

      //Add attachments reference - WEB-1415
      if(this.jobObject?.attachments?.length > 0 ){
        if(this.jobObject?.attachments?.length > 0){
          payload['attachment'] = this.jobObject?.attachments.map((attachment: any) => (
              {
              'file_name': attachment?.attachment_name ?? '',
              'url': attachment?.attachment_path ?? '',
              'attachment_uid': attachment?.attachment_uid ?? '',
              'company_attachment_uid': attachment?.attachment_uid ?? ''
            }
          ));
        }
      }

      if (formValue?.customer) {
        const customer: any = this.getCustomerDetails();
        payload['customer'] = {
          customer_uid: customer?.customer_uid,
          customer_first_name: customer?.customer_first_name,
          customer_last_name: customer?.customer_last_name,
          customer_email: customer?.customer_email
        };
        payload['customer_uid'] = customer['customer_uid'];
        if (formValue?.serviceAddress?.street) {
          payload['customer']['customer_address'] = this.contactInfoService.getContactInfoAddressModel(formValue?.serviceAddress);
        }
        if (formValue?.billingAddress?.street) {
          payload['customer']['customer_billing_address'] = this.contactInfoService.getContactInfoAddressModel(formValue?.billingAddress);
        }
      }
      if (formValue?.serviceAddress?.street) {
        payload['customer_address'] = this.contactInfoService.getContactInfoAddressModel(formValue?.serviceAddress);
      }
      if (formValue?.billingAddress?.street) {
        payload['customer_billing_address'] = this.contactInfoService.getContactInfoAddressModel(formValue?.billingAddress);
      }
      if (formValue.dueDate) {
        payload['due_date'] = this.customTimezone ? moment.tz(moment(formValue.dueDate).format('YYYY-MM-DD HH:mm:ss'),  this.customTimezone).utc().format('YYYY-MM-DD HH:mm:ss')
          : moment(formValue.dueDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
      }
      payload['job_category'] = formValue.category;
      payload['job_priority'] = formValue.priority;
      payload['job_title'] = formValue.jobTitle;
      if (formValue?.jobDescription) {
        payload['job_description'] = formValue?.jobDescription;
      }
      payload['job_tags'] = formValue.tags || [];
      if (formValue?.organization) {
        payload['organization'] = formValue?.organization;
      }
      if (formValue?.property) {
        payload['property'] = formValue?.property;
      }
      if (this.selectedCategoryServiceTask?.length) {
        payload['service_task'] = this.getServiceTaskPayload();
      }
      if (formValue?.job_timezone && this.utilityService.isTimeZoneEnabled) {
        payload['job_timezone'] = formValue?.job_timezone;
      }
      if (formValue.scheduleEndDate) {
        payload['scheduled_end_time'] = this.customTimezone ? moment.tz(moment(formValue.scheduleEndDate).format('YYYY-MM-DD HH:mm:ss'), this.customTimezone).utc().format('YYYY-MM-DD HH:mm:ss')
          : moment(formValue.scheduleEndDate).utc().format('YYYY-MM-DD HH:mm:ss');
      }
      if (formValue.scheduleStartDate) {
        payload['scheduled_start_time'] = this.customTimezone ? moment.tz(moment(formValue.scheduleStartDate).format('YYYY-MM-DD HH:mm:ss'), this.customTimezone).utc().format('YYYY-MM-DD HH:mm:ss')
          : moment(formValue.scheduleStartDate).utc().format('YYYY-MM-DD HH:mm:ss');
      }
      if((this.parentModuleData?.module === moduleKey.PROJECT) && this.parentModuleData?.moduleData){
        payload['project'] = this.parentModuleData.moduleData?.project_uid;
        payload['phase'] = this.parentModuleData.moduleData?.phase_uid;
      };

      this.creatingJob = true;
      const loader = this.toast.loading(this.utilityService.getLocaleValue('loader.alert.creating_job'), { duration: Infinity });
      this.dataCollectorService.postData(this.newJobService.newJobAPIurls.jobsUrl, {
        'job': payload
      }).subscribe((res: any) => {
        this.creatingJob = false;
        loader.close();
        if (res?.data?.message) {
          this.toast.success(res?.data?.message);
        } else {
          this.toast.success(this.utilityService.getLocaleValue('alert.job.created_successfully'));
        }
        this.jobFormEmitter.next({ isCreatedJob: true, job_uid: res.job_uid });
        this.closeNewJob();
      }, (err: any) => {
        this.creatingJob = false;
        loader.close();
      });
    }
  }

  advancedJobCreation(): void {
    const formValue: any = this.newJobForm.value;
    const job: any = {
      'job_title': formValue.jobTitle || '',
      'job_description': formValue.jobDescription || '',
      'customer': null,
      'organization': null,
      'property': null,
      'job_category': formValue.category || null,
      'job_tags': formValue.tags || [],
      'job_priority': formValue.priority || 'LOW',
      'due_date': null,
      'assigned_to': [],
      'scheduled_start_time': null,
      'scheduled_end_time': null,
      'customer_address': null,
      'customer_billing_address': null
    };

    if (formValue?.job_timezone && this.utilityService.isTimeZoneEnabled) {
      job['job_timezone'] = formValue?.job_timezone;
    }

    if (formValue.customer) {
      job['customer'] = this.customerOptions.find(value => value.customer_uid === formValue.customer) || null;
    }

    if (formValue.organization) {
      job['organization'] = this.organizationOptions.find(value => value.organization_uid === formValue.organization) || null;
    }

    if (formValue.property) {
      job['property'] = this.propertyOptions.find(value => value.property_uid === formValue.property) || null;
    }

    if (formValue.assignedTo?.length) {
      const assignedTo = formValue.assignedTo?.map((user: any) => ({
        team: user?.teams?.[0]?.team_uid ? user?.teams?.[0] : null,
        user: user || null
      }));
      job['assigned_to'] = assignedTo;
    }

    if (formValue.dueDate) {
      job['due_date'] = moment(formValue.dueDate).endOf('day').format('YYYY-MM-DD');
    }

    if (formValue.scheduleStartDate) {
      job['scheduled_start_time'] = this.customTimezone ? moment.tz(moment(formValue.scheduleStartDate).format('YYYY-MM-DD HH:mm:ss'), this.customTimezone).utc().format('YYYY-MM-DD HH:mm:ss')
      : moment(formValue.scheduleStartDate).utc().format('YYYY-MM-DD HH:mm:ss');
    }

    if (formValue.scheduleEndDate) {
      job['scheduled_end_time'] = this.customTimezone ? moment.tz(moment(formValue.scheduleEndDate).format('YYYY-MM-DD HH:mm:ss'), this.customTimezone).utc().format('YYYY-MM-DD HH:mm:ss')
      : moment(formValue.scheduleEndDate).utc().format('YYYY-MM-DD HH:mm:ss');
    }

    if (formValue.serviceAddress?.street) {
      job['customer_address'] = this.contactInfoService.getContactInfoAddressModel(formValue?.serviceAddress);
    }

    if (formValue.billingAddress?.street) {
      job['customer_billing_address'] = this.contactInfoService.getContactInfoAddressModel(formValue?.billingAddress);
    }

    if (this.jobObject?.job_description) {
      job['job_description'] = this.jobObject?.job_description;
    }
    this.jobFormEmitter.next({ isCreatedJob: false, action: 'ADVANCED_JOB', job: job });
    this.closeNewJob();
  }

  closeNewJob(): void {
    this.toggleDrawer(false);
  }

  toggleDrawer(isOpen: boolean): void {
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    if (isOpen) {
      this.timezoneSubscription = this.timezoneService.timeZones.subscribe((timezoneRes: Array<TimeZoneDataType>)=>{
        if(timezoneRes){
          this.timeZoneData = timezoneRes;
        }
      });
    }
    else {
      this.timezoneSubscription?.unsubscribe();
      this.cancelAllSubscribtion.next();
      this.showErrorMessage = false;
      this.errorMessage = '';
    }
    this.utilityService.castEventToSdk(`drawer.new_job.${isOpen ? 'open' : 'close'}`, {
      'current_page': this.currentPage,
      'module_data': this.parentModuleData
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isOpen ? drawer.open() : drawer.close();
  }

  setDate(picker: any, name: string): void {
    const date = this.newJobForm?.controls[name];
    if (!date?.value) {
      date?.setValue(moment(), { emitEvent: false });
    }
    picker.select(date?.status.toLowerCase() === 'valid' && date?.value !== undefined ?
    this.utilityService.getNextQuarterHour(moment(date?.value)) : moment(this.utilityService.getNextQuarterHour(moment(), true)));
    picker?.open();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.openDrawer?.previousValue !== undefined) {
      this.toggleDrawer(changes?.openDrawer.currentValue);
    }
  }

  // #region UI SDK
  subscribeFormValueChangesForSDKListeners(): void {
    const formValueSub$ = this.newJobForm?.valueChanges.pipe(distinctUntilChanged(), debounceTime(1000), pairwise()).subscribe(([prev, next]) => {
      this.utilityService.castEventToSdk(`drawer.new_job.change`, {
        oldValue: {
          ...prev,
          scheduleStartDate: this.utilityService.convertMomentToDate(prev.scheduleStartDate),
          scheduleEndDate: this.utilityService.convertMomentToDate(prev.scheduleEndDate),
          dueDate: this.utilityService.convertMomentToDate(prev.dueDate)
        },
        newValue: {
          ...next,
          scheduleStartDate: this.utilityService.convertMomentToDate(next.scheduleStartDate),
          scheduleEndDate: this.utilityService.convertMomentToDate(next.scheduleEndDate),
          dueDate: this.utilityService.convertMomentToDate(next.dueDate)
        },
        currentPage: this.currentPage
      });
    });
  }

  subscribePatchFormValueFromSDK(): void{
    const sub$ = this.utilityService.listenForFormPatchEvent('drawer.new_job').subscribe((res: any) => {
        let data = res.data
        if(data.controlName === 'scheduleStartDate' || data.controlName === 'scheduleEndDate' || data.controlName === 'dueDate'){
          this.newJobForm?.get(data.controlName)?.patchValue(moment(data.value));
        }
        else if(['organization', 'customer', 'property'].includes(data.controlName)){
          this.patchModuleDetailsBasedOnSDKEvent(data.controlName, data.value);
        }else{
          this.newJobForm?.get(data.controlName)?.patchValue(data.value);
        }
    })
  }

  patchModuleDetailsBasedOnSDKEvent(controlName: string, controlValue: any): void {
    switch(controlName){
      case 'organization':
        this.getOrganization({
          organization_uid: controlValue,
        });
        this.newJobForm?.get('organization')?.patchValue(controlValue?.organization_uid);
        break;
      case 'customer':
        this.getCustomer({
          customer_uid: controlValue,
        });
        this.newJobForm?.get('customer')?.patchValue(controlValue?.customer_uid);
        break;
      case 'property':
        this.getProperty({
          property_uid: controlValue,
        });
        this.newJobForm?.get('property')?.patchValue(controlValue?.property_uid);
        break;
    }
  }
  // #region UI SDK
}
